import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-delete-reflection',
  templateUrl: './alert-delete-reflection.component.html',
  styleUrls: ['./alert-delete-reflection.component.scss'],
})
export class AlertDeleteReflectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
